import index from './en/index'
import opportunity from './en/opportunity'
import chat from './en/chat'
import employee from './en/employee'
import collection from './en/collection'
import potentialOrder from './en/potentialOrder'
import hotspot from './en/hotspot'

export default {
  ...opportunity,
  ...chat,
  ...employee,
  ...collection,
  ...potentialOrder,
  ...hotspot,
  rLogin: {
    'systemTip': 'System tip',
    'loginExpired': 'The recording status has expired. Please log in again',
    'cancel': 'cancel',
    'loginAgain': 'login again'
  },
  language: {
    name: 'en'
  },
  ...index,
  tip: {
    success: 'Success',
    loading: 'Loading...'
  },
  live: {
    status: {
      '0': 'On live',
      '1': 'Upcoming',
      '2': 'Replay'
    },
    startTime: 'Start time',
    looker: 'Playback',
    toLive: 'Enter'
  },
  like: 'Like',
  exhibitorInfo: 'Details of the exhibitor',
  follow: 'View',
  joinExhibitorNum: 'Number of attendance',
  registeredCapital: 'Registered capital',
  scaleOfCompany: 'Scale of company',
  collect: ['Follow', 'Followed'],
  message: 'Contact',
  'Send message': 'Send message',
  invite: 'Add',
  details: 'Details',
  placeholder: 'Please enter your',
  pageView: 'Views',
  collection: 'Followed',
  editor: 'Edit',
  companyEditor: 'Edit company information',
  del: 'Delete',
  selectType: 'Select type',
  auditStatus: ['Passed', 'Pending', 'Failed to pass'],
  upgradeBrowser: 'Please upgrade the browser...',

  // Header translation
  logout: 'Logout',
  profile: 'Personal',
  notification: 'Message',
  myFavorite: 'My favorites',
  watchHistory: 'View history',
  customService: 'Customer service',
  serviceTel: 'Online customer Service:',
  invitation: 'Invitation',
  marketing: 'Marketing',
  moreFeature: 'More features',
  invitationManagement: "Contacts",
  operationGuide: 'Operation Guide',
  baseMess: 'Basic information',
  companyManage: 'Company information',
  companybaseMessManage: 'Personal information',
  exhibitsManage: 'Product management',
  actor: 'Visitors',
  exhibitors: 'Exhibitors',
  exhibits: 'Products',
  business: 'Business',
  find: 'Find',
  home: 'Home',
  baoiHome: 'Jinhan Fair Online Exhibition 2020',
  qatitle: 'Q&A',
  img: 'Image',
  video: 'Video',
  address: 'Address',
  tel: 'Tel',
  email: 'Email',
  www: 'Website',
  registerLogin: 'Login',
  // passLogin: 'Use password',
  // codeLogin: 'Use verification code',
  passLogin: 'By Email',
  codeLogin: 'By Mobile',
  ydjTip:'Registration is not yet open, so stay tuned!',
  getCode: 'Get verification code',
  login: 'Login',
  'You sign up and agree': 'Sign in and agree',
  'Privacy agreement': '《Privacy agreement》',
  register: 'New Registration',
  code: 'Verification Code',
  password: 'Password',
  phone: 'Mobile No',
  resetPassword: 'Set Password',
  newPassword: 'New password',
  inputAgain: 'Confirm Password',
  newPasswordAgain: 'Please type the password again',
  'Please enter your code': 'Please enter your code',
  confirm: 'Confirm',
  confirmPassword: 'Confirm Password',
  forgetPassword: 'Forgot password?',
  exhibitorCode: 'Exhibitor code',
  backLogin: 'Back to login',
  bindExhibitor: 'Bind exhibitor',
  setPassPageTip: [
    'We have sent you a verification code to confirm your email, please log in to your mailbox to check the verification code to complete your password setting.',
    'After setting the login password, you can use the password to log in'
  ],
  myIndentity: ['我是展商', 'I am exhibitor', '我是观众', 'I am visitor'],
  save: 'Save',
  'company name': 'Company name',
  name: 'Name',
  post: 'Title',
  country: 'Country',
  province: 'Province',
  city: 'City',
  emailCodeSendTip:
    'We have sent you a verification code to confirm your email, please log in to your mailbox to check the verification code to complete your password setting.',
  'The verification code has been sent': 'The verification code has been sent',
  // 'Please enter your correct email address': 'Please enter your correct email address',
  'Please enter your correct mobile': 'Please enter your correct mobile',
  'The two passwords you entered did not match': 'The two passwords entered did not match',
  'select placeholder': 'Please select',
  'Please upload your avatar': 'Please upload your profile photo',
  'Please enter your name': 'Please enter your name',
  'Please enter your company name': 'Please enter your company name',
  'Please enter your position': 'Please enter your title',
  'The mobile phone number already exists, please enter again':
    'The mobile phone number already exists, please enter again',
  'The mailbox already exists, please enter again': 'The mailbox already exists, please enter again',
  // TODO: chat feature
  'Camera not found, please check your browser settings.':
    'Camera not found, please check your browser settings',

  // exhibits form
  'Add Exhibit': 'Add Product',
  'My Exhibit List': 'My Product List',
  'Upload picture': 'Upload company logo',
  'Upload picture3': 'Upload photos',
  'Upload picture4': 'Employee profile image',
  'Upload picture2': 'Upload picture',
  'Upload again': 'Upload again',
  'Add picture': 'Add picture',
  'Only support png & jpg, less than 1Mb': 'No less than 1200*560 pixel, png or jpg format only, less than 2M',
  'Only support png & jpg, less than 1Mb 350px': 'No less than 350*350 pixel, png or jpg format only, less than 2M',
  'uploadTips2': 'Only support png & jpg, less than 2M',
  'Uploaded image only support png and jpg': 'For uploading image only support png and jpg!',
  'Uploaded image can not greater than 1Mb': 'For uploading image can not exceed 2M',
  'Uploaded image can not greater than 10Mb': 'For uploading image can not exceed 10M',
  'Upload video': 'Upload video',
  'Add video': 'Add video',
  'Only support mp4, less than 100Mb': 'Less than 100M',
  'Only support mp4, less than 10Mb': 'Less than 10M',
  'Uploaded video only support mp4': 'For uploading video only support mp4',
  'Uploaded video can not greater than 100Mb': 'For uploading video can not exceed 100M',
  'Uploaded video can not greater than 10Mb': 'For uploading video can not exceed 10M',
  'Upload long picture': 'Upload long picture',
  'Add product tags': 'Add product tags',
  'Product tags': 'Product tags',
  'Add form data': 'Add data',
  'Confirm and publish': 'Confirm and publish',
  Yes: 'Yes',
  No: 'No',
  'Please fill product name': 'Please type product name',
  'Please upload at least one picture': 'Please upload at least one picture',
  'Please select product tag': 'Please select product tag',
  'Please upload at least one long picture': 'Please upload at least one long picture',
  'Please select identity': 'Choose Your Role',
  // exhibit detail
  'Exhibitor Name': 'Exhibitor',
  'Exhibit Brand': 'Product Brand',
  'Minimum Order Quantity': 'Minimum Order Quantity',
  'Product BuyPrice': 'Purchase price',
  'Product SalePrice': 'Sale price',
  'Spot Trading': 'Spot Trading',
  'Product Identification': 'Product Identification',
  'Customization Services': 'Customized Services',
  'Visible scope': 'Visible scope',
  'Copy Link': 'Copy Link',
  Copied: 'Copied',
  'productSearch': 'Search by exhibit name or article number',
  // company info
  'Upload logo': 'Upload logo',
  'Add company tags': 'Add company tags',
  'Add company description': 'Add company description',
  'comingSoon': 'You are registered. Please visit Jinhan Fair on October 21-27',
  'setPassWord': "You haven’t set your password yet. Do you want to set it now?",
  'tips':'Warning',
  'ok':'OK',
  'cancel':'Cancel',
  'infoCn': 'Please switch to Chinese to view the information',
  'infoEn': 'Please switch to English to view the information',
  'aboutus': 'About Us',
  'comingSoon2': 'You have not completed the registration, please go to fill in now.',
  'auditTip':'Your registration is under review, please wait for the result patiently. Any questions, please feel free to contact info@jinhanfair.com.',
  'auditTip1':'Your registration is not approved. Please submit qualified information as required again. Any questions, please feel free to contact info@jinhanfair.com.',
  'resiInfo': 'Ok',
  'change': 'Change',
  'productError': 'Failed：product category cannot be more than 3',
  'exportCustomer': 'Export',
  'liveName':'Please enter the name of the live broadcast',
  "liveKeyWorld":"Search by keyword",

  'liveStartTime':"Please select the start time",
  'liveEndTime':"Please select the end time",

  'liveSponsorName':'Please enter exhibitor name',
  'messageMail': 'Notice',
  'Message management': 'Message management',
  'mail': {
    'INVITE': 'Meeting Invitation',
    'CHECKRESULT': 'Review Notifications',
    'SPONSOR': "Organizer's Notifications"
  },
  'goBack': 'Back',
  'smsCodeLogin': 'Log in via SMS',
  'passwordLogin': 'Log in via password',
  'registerTips': 'Please hold down the slider and drag it to the far right to verify',
  'registerSuccessTips': 'Verified successful',
  'slideCode':'Please slide the verification code',
  'Next': 'Next',
  'emailConfirmation': 'Confirm Email',
  // 'emailTitle': 'Please confirm your login information in the email',
  'emailTitle': 'Please confirm your login',
  'emailContent1': "We've sent you a confirmation email. Please check and click the",
  'emailContent2': ' confirmation link ',
  'emailContent3': 'to complete your registration.',
  'emailContent4': 'If you did not receive this message in your inbox, it may have been intercepted by the system, please look it up in the bin. Gmail users should check out the admail.',
  'resendMessage': 'Resend the e-mail',
  'Service Email': 'Email:',
  'infoExistence': 'This user is already exists',
  'codeRrror': 'Verification code is wrong',
  'Create Account': 'Create Account',
  'Confirm Email': 'Confirm Email',
  'Set Password': 'Set Password',
  'Fill in info': 'Fill in info',
  'Questionnaire': 'Questionnaire',
  'Completed': 'Completed',
  'Completed Registration': 'Registration Completed',
  'registerCompletedTips': 'Registration Confirmation',
  'registerSuccessContent': "Thanks for your registration of Jinhan Fair for Home & Gifts, the online exhibition will be held on 21-27,October. All information of exhibitors and products will be available at that moment.Let's look forward for it.",
  'registerCompletedTips1': 'Under Review',
  'registerSuccessContent1': "Thanks for your registration of Jinhan Fair for Home & Gifts, the online exhibition will be held on 21-27,October. All information of exhibitors and products will be available at that moment.Let's look forward for it.",
  // 'registerSuccessContent1': 'Thanks for your registraiton of Jinhan Fair for Home & Gifts. Your information is under review, please wait for the result patiently. Any questions, please feel free to contact info@jinhanfair.com.',
  'registerCompletedTips2': 'Not Approved',
  'registerSuccessContent2': 'Sorry that your registration of Jinhan Fair for Home & Gifts is not approved. Please submit qualified documents as required again. Any questions, please feel free to contact info@jinhanfair.com.',
  
  'goHome': 'Confirm',
  'Messag List': 'Message list',
  'baseInfo': 'Basic information',
  'Head Image1': 'Please upload your ID photo',
  'Head Image2': 'The photo will also be used for the exhibition entry certificate',
  'workPassTips': 'Please upload your personal work permit photo',
  'registrationTips': 'Please upload the photo of the 《registration certificate of your foreign regional representative office》',
  'Please select the visible range': 'Please select the visible range',
  'Please select the visible range2': 'Please select product tag or visible range',
  'Please select the exhibits to be modified': 'Please select the exhibits to be modified',
  'Batch editing': 'Batch editing',
  'Batch deletion': 'Batch deletion',
  'Select the current page': 'Select the current page',
  'No data on the current page': 'No data on the current page',
  'a olute or self-relative': 'a olute or self-relative',
  'exhformTisp': 'Notice: ',
  'exhformTisp1': 'Click rate  can lead to conversion rate',
  'exhformTisp2': 'Good product display can reflect the selling point better and attract buyers to click',
  'exhformTisp3': 'The following four points determine whether the customer clicks and continues browsing',
  'exhformTisp4': '1. Bright and beautiful, attracting clicks',
  'exhformTisp5': '2. Show multiple colors and styles',
  'exhformTisp6': '3. Show advantages or details',
  'exhformTisp7': '4. Explain preferential activities and promote order placement',
  'exhformTisp9': '1. Uploaded here is a picture of a single product, you can upload pictures of different angles and styles of the product.',
  'exhformTisp10': '2. The size is not less than 750*750 pixels, supports png, jpg format, not more than 2Mb, you can upload up to ten product Images.',
  'exhformTisp11': 'To improve click-through rate, main video must go first',
  'exhformTisp12': 'Buyers are more willing to see vivid Videos rather than flat pictures.',
  'exhformTisp13': 'Buyers will see the product video before seeing the product Image.',
  'exhformTisp14': 'The video cover appears in the video location when the video is not playing',
  'exhformTisp15': '1. Video cover should be png, jpg format, no more than 1Mb, you can upload only one cover image.',
  'exhformTisp16': '2. Video should be mp4 format, no more than 100Mb, you can upload one video.',
  'exhformTisp17': '3. The best display effect can be obtained only when the video cover and the video are square.',
  'exhformTisp18': 'Choose your product labels accurately to help you match quality buyers more accurately.',
  'exhformTisp19': 'The details need to be exciting to increase the conversion rate.',
  'exhformTisp20': 'Upload details of your exhibits, highlight product positioning and selling points, to stand out from the crowd.',
  'exhformTisp21': 'Tell stories, introduce products, and describe scenes with exquisite graphics.',
  'exhformTisp22': '1. Upload the detailed images and texts of the exhibits here. In order to obtain the best display effect and loading speed, the images need to be uploaded in parts.',
  'exhformTisp23': '2. The recommended size of each picture is 1200*600, support png, jpg format, no more than 1Mb',
  'Cancel the full selection': 'Cancel the full selection.',
  'releaseTips':'You can publish supply information in News Feeds, and the customer target that matches your choice will see your release through his/her business network, bringing you business opportunities.',
  'hot exhibits': 'Hot Exhibits',
  'productRangeTip': 'The total number of all visible products can be uploaded up to 10, and the number of other ranges is unlimited',
  'productRangeTip2': ['A total of ', ' sheets, you can also upload ', ' sheets'],
  'contactPerson': 'Your account does not exist, please contact your company administrator to create',
  'noPassword': 'No password is set for this account, please set the password first, and it will automatically jump to the password setting page within 3 seconds',
  'invitationCode': 'Invitation Code',
  'invitationCodeTips1': '1.Exhibitors can send the invitation code to the target audience',
  'invitationCodeTips2': '2.The audience can view live broadcasts and exhibits that are only visible to the customer pool through the invitation Code',
  'invitationCodeTips3': '3.The audience invited by the invitation code will directly join your customer pool',
  'clickCopy': 'Click to copy',
  'actorLoginTips': 'Note: If the account has been created, please click "Forgot Password" to set the password first when logging in',

  'note2': 'Please note:',
  'noteText': ['at most ', ' can be selected'],
  'Please upload a cover image of the video while uploading the video. Otherwise the front-end display will be blank.': 'Please upload a cover image of the video while uploading the video. Otherwise the front-end display will be blank.',
  'Please upload Video.': 'Please upload Video.',
  'Watch the live stream.': 'Watch the live stream.',
  'You need to invite exhibitors, or use the invitation code to watch the live broadcast': 'You need to invite exhibitors, or use the invitation code to watch the live broadcast',
  'To watch the live broadcast, please invite the exhibitor immediately or enter the invitation code to watch.': 'To watch the live broadcast, please invite the exhibitor immediately or enter the invitation code to watch.',
  'Invite now': 'Invite now',
  'Or, enter the invitation code and watch': 'Or, enter the invitation code and watch',
  'Please enter the invitation code': 'Please enter the invitation code',
  'Contact exhibitors via IM to get the invitation code': 'Contact exhibitors via IM to get the invitation code', 
  'determine': 'OK',
  'actorDetailRegister': 'Register now to view more products',
  'actorDetailInite': 'Invite exhibitors to view more products',
  'actorDetailInite2': 'or, enter the invitation code and view directly',
  'Invitation code error': 'Invitation code error',
  'Password error': 'Password error',
  'Private live broadcasting': 'Private live broadcasting',
  'inviteTips': "Successfully invited exhibitors can join the exhibitor's client pool to see more exhibitors and live streams authorized by the exhibitor.",
  'For details, please invite exhibitors': 'For details, please invite exhibitors',
  'Unregistered users can only see limited products. Please register to view more.': 'Unregistered users can only see limited products. Please register to view more.',
  'inviteTips2': 'You may see more products in company page when you are approved by the exhibitor. Please click “invite”.',
  'onLine': '本机网络已连接，请刷新您的页面',
  'offLine': '本机网络掉线, 请检查您的网络',
  'withoutPermission': 'The current account has not activated this function, please contact the organizer to activate the rights.',
  'Modify file name': 'Modify file name',
  'This will permanently delete the file. Continue?': 'This will permanently delete the file. Continue?',
  'Delete completed': 'Delete completed',
  'Please enter a file name': 'Please enter a file name',
  'filename is incorrect': 'filename is incorrect',
  'Revise Success': 'Revise Success',
  'Upload information': 'Upload information',
  'Exhibitor information': 'Exhibitor information',
  '编辑公司资料': 'Edit Company Information',
  '编辑展品资料': 'Edit Exhibit Materials',
  '如何管理公司资料': 'How to manage company data',
  '如何管理展品': 'How to manage exhibits',
  '本平台仅对正式参展商开放服务': 'This platform is only open to official exhibitors',
  '请使用报名参展手机号登录系统': 'Please use your mobile phone to log in to the system',
  '面料展展商平台使用指南': 'Guide for use of fabric exhibitor platform'
}
